export const NEXT_PAGE_ACTION = 'NEXT_PAGE';
export const PREV_PAGE_ACTION = 'PREV_PAGE';
export const GO_TO_PAGE_ACTION = 'GO_TO_PAGE';
export const SEARCH_ACTION = 'SEARCH_PAGE';
export const SORT_ACTION = 'SORT_PAGE';
export const IS_LOADING_ACTION = 'IS_LOADING';
export const SET_DATA_ACTION = 'SET_DATA_PAGE';
export const SET_ERROR_ACTION = 'SET_ERROR_PAGE';
export const SET_PAGE_SIZE_ACTION = 'SET_PAGE_SIZE';
